import { FC } from 'react';
import map from 'lodash/map';
import Item, { FormItemProps } from 'antd/lib/form/FormItem';
import Password from 'antd/lib/input/Password';

import { passwordRules } from 'utils/constants/constants';

const passwordFields: FormItemProps[] = [
  { name: 'oldPassword', label: 'Old Password' },
  {
    name: 'newPassword',
    label: 'New Password',
    dependencies: ['oldPassword'],
    rules: [
      ({ getFieldValue }) => ({
        validator(_, value) {
          if (getFieldValue('oldPassword') === value) {
            return Promise.reject(new Error('Can\'t be the same as old password'));
          }

          return Promise.resolve();
        },
      }),
    ],
  },
  {
    name: 'confirmPassword',
    label: 'Confirm New Password',
    dependencies: ['newPassword'],
    rules: [
      ({ getFieldValue }) => ({
        validator(_, value) {
          if (getFieldValue('newPassword') === value) {
            return Promise.resolve();
          }

          return Promise.reject(new Error('Must match with new password'));
        },
      }),
    ],
  },
];

const ChangePasswordForm: FC = () => (
  <>
    {map(passwordFields, ({ rules = [], ...rest }, key) =>
      <Item key={key} validateFirst rules={[...passwordRules, ...rules]} {...rest}>
        <Password size="large" placeholder={`Enter ${rest.label}`} />
      </Item>)}
  </>
);

export default ChangePasswordForm;
